import React from 'react'
import { Box, Typography } from '@mui/material';
import { CustomButton } from "components/CustomButton";
import GridItem from 'components/Grid/GridItem.jsx'

export const CompleteProfileAlert = ({ history, themeColor }) => {
  const defaultColor = themeColor?.navigation?.buttons?.backgroundColor || '#000000'

  return (
    <GridItem xs={12}>
      <Box
        gap={1}
        p="5px"
        width="99%"
        display="flex"
        borderRadius="4px"
        bgcolor="#FFA200"
        justifyContent="space-between"
        marginBottom="16px"
      >
        <Box display="flex" gap={1} alignItems="center" pl="5px">
          <Box
            component="i"
            className="icon-alerta"
            sx={{
              color: '#ffffff',
              fontSize: '16px',
            }}
          />
          <Typography
            variant="body1"
            color="#ffffff"
            fontStyle="italic"
            fontSize="14px"
          >
            Complete seu cadastro para liberar as funcionalidades de pagamento!
          </Typography>
        </Box>

        <CustomButton
          size="sm"
          variant="outlined"
          bgColor="#ffffff"
          style={{
            height: '28px',
            borderColor: '#ffffff',
            fontSize: '12px',
          }}
          defaultColor={defaultColor}
          onClick={() => history.push('/profile?edit=true')}
        >
          Completar cadastro
        </CustomButton>
      </Box>
    </GridItem>
  );
};
